import { render } from "./sidebarPrint.vue?vue&type=template&id=fc0a5272&ts=true"
import script from "./sidebarPrint.vue?vue&type=script&lang=ts"
export * from "./sidebarPrint.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__